(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lf-card-scene"] && !Shopify.designMode) return;
  try {
    (() => {
    function connectScenes(scope) {
      scope.querySelectorAll('.lf-scene-preview:not([data-connected])').forEach(scene => {
        scene.dataset.connected = 'true';
        const image = scene.querySelector('img');
        const refresh = () => { scene.dataset.ready = String(image.complete && image.naturalWidth > 0); };
        image.addEventListener('load', refresh);
        image.addEventListener('error', () => { scene.dataset.ready = 'false'; });
        refresh();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => connectScenes(document), {once:true});
    else connectScenes(document);
    document.addEventListener('shopify:section:load', event => connectScenes(event.target));
  })();

  (() => {
    if(customElements.get('lf-card-gallery')) return;
    class LivingFunCardGallery extends HTMLElement {
      connectedCallback(){
        if(this.controller) return;
        this.controller=new AbortController();
        this.phone=matchMedia('(max-width:699px)');
        this.change=()=>this.phone.matches?this.mount():this.unmount();
        this.phone.addEventListener('change',this.change,{signal:this.controller.signal});
        // The element can connect before its template has finished parsing.
        if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',this.change,{once:true,signal:this.controller.signal});
        else this.change();
      }
      disconnectedCallback(){
        this.unmount();
        this.controller?.abort();
        this.controller=null;
      }
      mount(){
        if(this.track || this.closest('lfx-color-studio')) return;
        const first=this.parentElement.querySelector(':scope>img');
        const template=this.querySelector('template');
        if(!first||!template||!template.content.querySelector('img')) return;
        this.events=new AbortController();
        const signal=this.events.signal;
        this.track=document.createElement('span');
        this.track.className='lf-card-gallery__track';
        this.track.setAttribute('aria-hidden','true');
        const images=[first.cloneNode(true),...Array.from(template.content.querySelectorAll('img'),img=>img.cloneNode(true))];
        this.slides=images.map(img=>{
          img.removeAttribute('id');img.alt='';img.draggable=false;
          const slide=document.createElement('span');slide.className='lf-card-gallery__slide';slide.append(img);this.track.append(slide);return slide;
        });
        this.count=document.createElement('span');
        this.count.className='lf-card-gallery__count';
        this.count.setAttribute('aria-hidden','true');
        this.count.innerHTML='<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.3"><path d="m7.5 2-4 4 4 4"/></svg><span></span><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.3"><path d="m4.5 2 4 4-4 4"/></svg>';
        this.append(this.track,this.count);
        this.parentElement.classList.add('lf-card-gallery-ready');
        this.index=0;this.blockClickUntil=0;
        this.update();
        const observe=new IntersectionObserver(entries=>{
          if(entries.some(entry=>entry.isIntersecting)){this.update();this.loadNear(this.index);observe.disconnect();}
        },{rootMargin:'100px'});
        this.observer=observe;observe.observe(this);
        this.track.addEventListener('pointerdown',event=>{
          if(!event.isPrimary) return;
          this.blockClickUntil=0;
          this.gesture={id:event.pointerId,x:event.clientX,y:event.clientY};
          this.loadNear(this.index);
        },{passive:true,signal});
        this.track.addEventListener('pointermove',event=>{
          const start=this.gesture;
          if(start?.id!==event.pointerId) return;
          if(Math.hypot(event.clientX-start.x,event.clientY-start.y)>10) this.blockClickUntil=performance.now()+500;
        },{passive:true,signal});
        const end=()=>{this.gesture=null;};
        this.track.addEventListener('pointerup',end,{passive:true,signal});
        this.track.addEventListener('pointercancel',end,{passive:true,signal});
        // A drag or a scrolling finger release must not follow the product link.
        this.addEventListener('click',event=>{
          if(performance.now()<this.blockClickUntil){event.preventDefault();event.stopPropagation();}
        },{capture:true,signal});
        this.track.addEventListener('scroll',()=>{
          this.blockClickUntil=performance.now()+250;
          if(this.frame) return;
          this.frame=requestAnimationFrame(()=>{this.frame=0;this.update();this.loadNear(this.index);});
        },{passive:true,signal});
        this.closest('a').addEventListener('keydown',event=>{
          if(!['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();event.stopPropagation();
          const next=Math.max(0,Math.min(this.slides.length-1,this.index+(event.key==='ArrowRight'?1:-1)));
          this.loadNear(next);this.track.scrollTo({left:next*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
        },{signal});
      }
      loadNear(index){
        [index-1,index,index+1].forEach(i=>{
          const img=this.slides[i]?.firstElementChild;
          if(!img?.dataset.src) return;
          img.sizes=img.dataset.sizes;img.srcset=img.dataset.srcset;img.src=img.dataset.src;
          delete img.dataset.src;delete img.dataset.srcset;delete img.dataset.sizes;
          img.addEventListener('error',()=>{img.srcset='';img.src=this.slides[0].firstElementChild.currentSrc||this.slides[0].firstElementChild.src;},{once:true,signal:this.events.signal});
        });
      }
      update(){
        if(!this.track?.clientWidth) return;
        this.index=Math.max(0,Math.min(this.slides.length-1,Math.round(this.track.scrollLeft/this.track.clientWidth)));
        this.count.querySelector('span').textContent=`${this.index+1} / ${this.slides.length}`;
        this.dataset.index=String(this.index);
      }
      unmount(){
        this.events?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);this.frame=0;
        this.track?.remove();this.count?.remove();this.track=null;this.count=null;
        this.parentElement?.classList.remove('lf-card-gallery-ready');
      }
    }
    customElements.define('lf-card-gallery',LivingFunCardGallery);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lf-discovery"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.LivingFunDiscovery) return;
  const alias = {cats:'cat',kitty:'cat',kitties:'cat',kitten:'cat',kittens:'cat',feline:'cat',dogs:'dog',pup:'dog',pups:'dog',puppy:'dog',puppies:'dog',canine:'dog',flowers:'flower',floral:'flower',blooms:'flower',runners:'runner',rugs:'mat',rug:'mat',mats:'mat',carpet:'mat',grey:'gray',colour:'color',colours:'color',ducks:'duck',geese:'goose',capybaras:'capybara'};
  const decode = value => String(value || '').replace(/&(?:quot|apos|amp|lt|gt|#\d+|#x[0-9a-f]+);/gi, entity => {
    const named = {'&quot;':'"','&apos;':"'",'&amp;':'&','&lt;':'<','&gt;':'>'};
    if(named[entity.toLowerCase()])return named[entity.toLowerCase()];
    const hex=/^&#x/i.test(entity),number=parseInt(entity.slice(hex?3:2,-1),hex?16:10);
    return number>0 && number<=0x10ffff ? String.fromCodePoint(number) : entity;
  });
  const clean = value => decode(value).normalize('NFKC').toLowerCase().replace(/[×✕＊*]/g,'x').replace(/[’‘]/g,"'");
  const words = value => (clean(value).match(/[a-z0-9]+/g) || []).map(word => alias[word] || word);
  const sizeOf = value => {
    const text = clean(value);
    const metric = text.match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)\s*cm\b/);
    if (metric) return [Number(metric[1]),Number(metric[2])].sort((a,b)=>a-b).join('x');
    const round = text.match(/[ø⌀]\s*(\d+(?:\.\d+)?)\s*cm\b/);
    return round ? [Number(round[1]),Number(round[1])].join('x') : null;
  };
  const queryParts = value => {
    const text = clean(value);
    const dimensions = text.match(/(\d+(?:\.\d+)?)\s*(?:cm|centimeters?)?\s*(?:x|by)\s*(\d+(?:\.\d+)?)\s*(?:cm|centimeters?)?\b/);
    const diameter = text.match(/[ø⌀]\s*(\d+(?:\.\d+)?)\s*(cm)?\b/);
    let size = null, rest = text;
    if (dimensions) {
      size = [Number(dimensions[1]),Number(dimensions[2])].sort((a,b)=>a-b).join('x');
      rest = rest.replace(dimensions[0],' ');
    } else if (diameter) {
      size = [Number(diameter[1]),Number(diameter[1])].join('x');
      rest = rest.replace(diameter[0],' ');
    }
    // Split only explicit color + known theme combinations in the search query.
    // Keep the shared words() parser unchanged for catalog data and recommendations.
    const queryThemes=new Set(['cat','dog','flower','duck','goose','capybara']);
    const tokens=words(rest).filter(word=>!['cm','centimeter','centimeters'].includes(word)).flatMap(token=>{
      const color=[...colorNames,'grey'].find(name=>{
        if(!token.startsWith(name))return false;
        const theme=token.slice(name.length);
        return queryThemes.has(alias[theme] || theme);
      });
      if(!color)return [token];
      const theme=token.slice(color.length);
      return [alias[color] || color,alias[theme] || theme];
    });
    return {size,tokens};
  };
  const near = (a,b) => {
    if (a === b) return true;
    if (a.length < 4 || b.length < 3 || Math.abs(a.length-b.length)>1) return false;
    let i=0,j=0,changes=0;
    while(i<a.length && j<b.length) {
      if(a[i]===b[j]) {i++;j++;continue;}
      if(++changes>1) return false;
      if(a.length>b.length) i++;
      else if(b.length>a.length) j++;
      else {i++;j++;}
    }
    return changes + (i<a.length || j<b.length ? 1 : 0) <= 1;
  };
  const colorNames = ['blue','green','pink','red','orange','purple','brown','black','white','cream','beige','yellow','gray','multicolor'];
  const mergedColorSkus = new Set(["MDGZ0917-8080", "MDGZ0919-8080", "CDGZ0587-4070", "CDGZ0587-60120", "CDGZ0593-4070", "CDGZ0593-60120", "CDGZ0783-5080", "CDGZ0784-4060", "CDGZ0784-5080", "CDGZ0562-5080", "CDGZ0373-50150", "CDGZ0372-5080", "CDGZ0372-50150", "CDGZ0902-4060", "CDGZ0901-4060"]);
  const variantColors = (product,variant) => {
    const own = words([variant.title,variant.label].join(' ')).filter(word=>colorNames.includes(word));
    if(Array.isArray(variant.colors)) return new Set([...words(variant.colors.join(' ')),...(mergedColorSkus.has(variant.sku) ? [] : own)].filter(word=>colorNames.includes(word)));
    const styles=new Set((product.variants || []).map(option=>clean(option.title || product.title).trim()));
    const inherited=styles.size<=1 ? (product.tags || []).filter(tag=>tag.startsWith('lf-color-')).map(tag=>tag.slice(9)) : [];
    return new Set([...words(inherited.join(' ')),...own].filter(word=>colorNames.includes(word)));
  };
  const searchable = (product,variant,colors) => {
    const tags=(product.tags || []).filter(tag=>!/^lf-(?:size|color)-/.test(tag));
    const parentWords=words(product.title).filter(word=>!colorNames.includes(word));
    const terms=new Set([...parentWords,...words([variant.title,product.type,tags.join(' '),variant.sku,variant.label].join(' ')),...colors]);
    if(colors.size)terms.add('color');
    return terms;
  };
  const find = (products,query) => {
    const parts=queryParts(query);
    if(!parts.size && !parts.tokens.length) return {matches:[],fuzzy:false};
    let correctedRunner=false;
    parts.tokens=parts.tokens.map(token=>{
      if(token==='runner')return token;
      if(token.length>=3 && 'runner'.startsWith(token))return 'runner';
      if(near(token,'runner')) {correctedRunner=true;return 'runner';}
      return token;
    });
    const run = fuzzy => {
      const result=[];
      for(const product of products) {
        let best=null;
        for(const variant of product.variants || []) {
          if(parts.size && sizeOf(variant.label)!==parts.size) continue;
          if(parts.tokens.includes('runner') && !variant.runner) continue;
          const colors=variantColors(product,variant);
          const terms=searchable(product,variant,colors);
          if(variant.runner)terms.add('runner');
          const has=token=>{
            const colorMatches=colorNames.filter(color=>color===token || (token.length>=3 && color.startsWith(token)) || (fuzzy && near(token,color)));
            if(colorMatches.length)return colorMatches.some(color=>colors.has(color));
            return terms.has(token) || (!/^\d+$/.test(token) && Array.from(terms).some(word=>word.startsWith(token))) || (fuzzy && Array.from(terms).some(word=>near(token,word)));
          };
          if(!parts.tokens.every(has)) continue;
          const titleWords=new Set(words(product.title));
          const variantWords=new Set(words([variant.title,variant.label].join(' ')));
          const score=parts.tokens.reduce((n,token)=>n+((titleWords.has(token)?8:terms.has(token)?3:1)+(variantWords.has(token)?6:0)),0)+(parts.size?12:0);
          const match={product,variant,score};
          if(!best || score>best.score || (score===best.score && variant.available && !best.variant.available)) best=match;
        }
        if(best) result.push(best);
      }
      return result.sort((a,b)=>b.score-a.score || Number(b.variant.available)-Number(a.variant.available) || a.product.title.localeCompare(b.product.title));
    };
    const exact=run(false);
    return exact.length ? {matches:exact,fuzzy:correctedRunner} : {matches:run(true),fuzzy:true};
  };
  const recommend = (products,current) => {
    const excluded=new Set([String(current.id),...(current.siblings || []).map(String)]);
    const currentTags=new Set(current.tags || []);
    const currentSize=sizeOf(current.label);
    const currentProduct=products.find(product=>String(product.id)===String(current.id));
    const currentVariants=(currentProduct?.variants || []).filter(variant=>current.sku && variant.sku===current.sku);
    const currentColors=new Set(currentVariants.length===1 && Array.isArray(currentVariants[0].colors) ? currentVariants[0].colors.filter(color=>colorNames.includes(color)) : []);
    const matches=[];
    for(const product of products) {
      if(excluded.has(String(product.id))) continue;
      const shared=(product.tags || []).filter(tag=>currentTags.has(tag));
      const theme=shared.some(tag=>tag.startsWith('lf-theme-'));
      const shape=shared.some(tag=>tag.startsWith('lf-shape-'));
      const style=shared.some(tag=>tag.startsWith('lf-style-'));
      let best=null;
      for(const variant of product.variants || []) {
        if(!variant.available || (current.sku && variant.sku===current.sku)) continue;
        const color=Array.isArray(variant.colors) && variant.colors.some(value=>currentColors.has(value));
        const sameSize=Boolean(currentSize && sizeOf(variant.label)===currentSize);
        const score=(theme?8:0)+(color?4:0)+(sameSize?3:0)+(shape?2:0)+(style?1:0);
        if(score<3) continue;
        const match={product,variant,score,reason:theme?'theme':color?'color':sameSize?'size':'style'};
        if(!best || score>best.score) best=match;
      }
      if(best) matches.push(best);
    }
    return matches.sort((a,b)=>b.score-a.score || a.product.title.localeCompare(b.product.title)).slice(0,4);
  };
  const card = (match,labels) => {
    const {product,variant}=match;
    const article=document.createElement('article');article.className='lf-discovery-card';
    const link=document.createElement('a');link.className='lf-discovery-card__link';
    const url=new URL(product.url,location.origin);url.searchParams.set('variant',variant.id);link.href=url.pathname+url.search;
    const picture=document.createElement('div');picture.className='lf-discovery-card__image';
    if(variant.image) {
      const img=document.createElement('img');img.src=variant.image;img.alt=variant.alt || product.title;img.width=600;img.height=800;img.loading='lazy';img.decoding='async';picture.append(img);
    }
    if(variant.scene) {
      const scene=document.createElement('span');scene.className='lf-discovery-card__scene';
      const img=document.createElement('img');img.alt=variant.sceneAlt || product.title;img.width=600;img.height=800;img.loading='lazy';img.decoding='async';
      img.addEventListener('load',()=>scene.classList.toggle('is-ready',img.naturalWidth>0));img.addEventListener('error',()=>scene.classList.remove('is-ready'));img.src=variant.scene;
      scene.append(img);picture.append(scene);
    }
    if(!variant.available) {const badge=document.createElement('span');badge.className='lf-discovery-card__badge';badge.textContent=labels.soldOut;picture.append(badge);}
    const arrow=document.createElement('span');arrow.className='lf-discovery-card__arrow';arrow.setAttribute('aria-hidden','true');arrow.textContent='↗';picture.append(arrow);
    const title=document.createElement('h3');title.textContent=variant.title || product.title;
    const price=document.createElement('p');price.className='lf-discovery-card__price';price.textContent=decode(variant.price);
    const size=document.createElement('p');size.className='lf-discovery-card__size';size.textContent=decode(variant.label);
    link.append(picture,title,price,size);article.append(link);
    if(match.reason && labels[match.reason]) {const reason=document.createElement('p');reason.className='lf-discovery-card__reason';reason.textContent=labels[match.reason];article.append(reason);}
    return article;
  };
  const requests=new Map();
  const load = async initial => {
    if(requests.has(initial)) return requests.get(initial);
    const pending=(async()=>{
      let next=new URL(initial,location.origin),products=[];const seen=new Set(),ids=new Set();
      while(next) {
        if(next.origin!==location.origin || seen.has(next.href)) throw new Error('Invalid catalog pagination');
        seen.add(next.href);
        next.searchParams.set('section_id','lf-catalog-index');
        const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),12000);
        let response,markup;
        try {
          response=await fetch(next.href,{signal:controller.signal,headers:{Accept:'text/html'}});
          if(!response.ok) throw new Error('Catalog request failed');
          markup=await response.text();
        } finally {clearTimeout(timeout);}
        const doc=new DOMParser().parseFromString(markup,'text/html');
        const dataNode=doc.querySelector('[data-lf-catalog]');
        if(!dataNode) throw new Error('Catalog unavailable');
        const data=JSON.parse(dataNode.textContent);
        if(!Array.isArray(data.products)) throw new Error('Invalid catalog');
        data.products.forEach(product=>{if(!ids.has(product.id)){products.push(product);ids.add(product.id);}});
        next=data.next ? new URL(data.next,location.origin) : null;
      }
      return products;
    })();
    requests.set(initial,pending);
    try{return await pending;}catch(error){requests.delete(initial);throw error;}
  };
  window.LivingFunDiscovery={words,sizeOf,queryParts,find,recommend,card,load};
  if(!customElements.get('lf-smart-search')) customElements.define('lf-smart-search',class extends HTMLElement {
    connectedCallback() {
      if(this.events) return;
      this.events=new AbortController();this.form=this.querySelector('form[role=search]');this.input=this.form?.querySelector('[name=q]');
      this.output=this.querySelector('[data-lf-search-output]');this.native=this.querySelector('[data-lf-native-search]');
      this.nativeURL=this.cleanURL(location.href).href;
      this.status=this.querySelector('[data-lf-search-status]');this.grid=this.querySelector('[data-lf-search-grid]');this.empty=this.querySelector('[data-lf-search-empty]');
      this.more=this.querySelector('[data-lf-search-more]');this.labels=JSON.parse(this.querySelector('[data-lf-search-labels]').textContent);
      this.pageSize=Number(this.dataset.pageSize) || 24;
      this.form.addEventListener('submit',event=>{
        if(!this.input.value.trim()) return;
        event.preventDefault();
        const url=new URL(this.form.action,location.origin);url.searchParams.set('q',this.input.value.trim());url.searchParams.set('type','product');
        this.savePosition();this.pendingPosition=null;
        history.pushState({},'',url);this.run(this.input.value.trim(),true);
      },{signal:this.events.signal});
      this.more.addEventListener('click',()=>this.showMore(true),{signal:this.events.signal});
      this.grid.addEventListener('click',event=>this.recordProductVisit(event),{signal:this.events.signal});
      this.native?.addEventListener('click',event=>this.recordProductVisit(event),{signal:this.events.signal});
      window.addEventListener('popstate',()=>{
        this.input.value=new URL(location.href).searchParams.get('q') || '';
        this.pendingPosition=this.historyPosition();this.run(this.input.value,false);
      },{signal:this.events.signal});
      window.addEventListener('pagehide',()=>this.savePosition(),{signal:this.events.signal});
      window.addEventListener('pageshow',event=>{
        if(!event.persisted)return;
        this.pendingPosition=this.historyPosition();
        if(this.matches || this.pendingPosition?.mode==='native')this.restorePosition();
      },{signal:this.events.signal});
      this.pendingPosition=this.takeBrowseRestore() || this.historyPosition();
      if(this.input.value.trim()) this.run(this.input.value.trim(),false);
    }
    disconnectedCallback(){this.events?.abort();this.events=null;this.serial=(this.serial || 0)+1;}
    cleanURL(value) {
      const url=new URL(value,location.href);
      url.searchParams.delete('section_id');url.searchParams.delete('sections');url.hash='';
      return url;
    }
    productKey(value) {
      const url=this.cleanURL(value);
      if(url.origin!==location.origin)return null;
      const match=url.pathname.match(/\/products\/([^/]+)\/?$/);
      return match ? '/products/'+match[1] : null;
    }
    validPosition(value,maxAge) {
      if(!value || value.v!==1 || value.kind!=='search' || typeof value.url!=='string' || !Number.isFinite(value.at))return null;
      const age=Date.now()-value.at;
      if(!Number.isFinite(age) || age<0 || age>maxAge)return null;
      if(!Number.isFinite(value.x) || !Number.isFinite(value.y) || value.x<0 || value.y<0 || value.x>10000000 || value.y>10000000)return null;
      if(!Number.isInteger(value.shown) || value.shown<1 || value.shown>10000)return null;
      if(value.mode!==undefined && value.mode!=='native')return null;
      try {
        const url=this.cleanURL(value.url);
        if(url.origin!==location.origin || !/\/search\/?$/.test(url.pathname) || url.href!==this.cleanURL(location.href).href)return null;
        return {...value,url:url.href};
      }catch(error){return null;}
    }
    takeBrowseRestore() {
      let saved;
      try {
        const raw=sessionStorage.getItem('lfBrowseRestoreV1');
        sessionStorage.removeItem('lfBrowseRestoreV1');
        if(!raw)return null;saved=JSON.parse(raw);
      }catch(error){return null;}
      const position=this.validPosition(saved,120000);
      if(!position || !document.referrer)return null;
      try {
        const referrer=this.cleanURL(document.referrer),from=this.cleanURL(position.from);
        const target=this.productKey(referrer.href);
        if(!target || referrer.origin!==location.origin || referrer.href!==from.href || target!==position.target)return null;
        return position;
      }catch(error){return null;}
    }
    historyPosition(){return this.validPosition(history.state?.lfSearch,1800000);}
    nativeResultCount() {
      // This is the rendered native page, not the smart-search match total.
      if(!this.native || this.nativeURL!==this.cleanURL(location.href).href || !this.native.querySelector('.lf-search__result-count[role=status]'))return 0;
      return this.native.querySelectorAll('.lf-commerce-product-grid .lf-product-card__link[href]').length;
    }
    savePosition() {
      if(this.cleanURL(location.href).href!==this.appliedURL)return null;
      const nativeCount=!this.matches && this.native && !this.native.closest('[hidden]') ? this.nativeResultCount() : 0;
      if(!nativeCount && (!this.matches || !this.shown))return null;
      const position={v:1,kind:'search',url:this.appliedURL,at:Date.now(),x:scrollX,y:scrollY,shown:nativeCount || this.shown,...(nativeCount?{mode:'native'}:{})};
      try {history.replaceState({...history.state,lfSearch:position},'',location.href);}catch(error){}
      return position;
    }
    recordProductVisit(event) {
      const link=event.target.closest?.('a');
      const nativeLink=link && !this.matches && this.native && !this.native.closest('[hidden]') && this.native.contains(link) && link.matches('.lf-product-card__link[href]');
      if(!link || (!this.grid.contains(link) && !nativeLink) || event.defaultPrevented || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || (link.target && link.target.toLowerCase()!=='_self') || link.hasAttribute('download'))return;
      let target;
      try {target=this.productKey(link.href);}catch(error){return;}
      if(!target)return;
      const position=this.savePosition();if(!position)return;
      try {sessionStorage.setItem('lfBrowsePendingV1',JSON.stringify({...position,target,from:position.url}));}catch(error){}
    }
    restorePosition() {
      const position=this.pendingPosition;
      if(!position)return;
      const native=position.mode==='native';
      if(native ? (!this.native || this.native.closest('[hidden]') || !this.nativeResultCount()) : !this.matches)return;
      this.pendingPosition=null;
      if(!native) {
        const desired=Math.min(position.shown,this.matches.length);
        while(this.shown<desired)this.showMore(false);
      }
      requestAnimationFrame(()=>requestAnimationFrame(()=>{
        if(this.isConnected && this.cleanURL(location.href).href===position.url)window.scrollTo({left:position.x,top:position.y,behavior:'instant'});
      }));
    }
    async run(query,submitted) {
      this.appliedURL=this.cleanURL(location.href).href;
      if(submitted)this.pendingPosition=null;
      const serial=this.serial=(this.serial || 0)+1;
      if(!submitted && this.pendingPosition?.mode==='native' && this.nativeResultCount()) {
        this.matches=null;this.grid.replaceChildren();this.more.hidden=true;this.empty.hidden=true;
        this.output.hidden=true;this.native.hidden=false;this.grid.removeAttribute('aria-busy');
        this.restorePosition();return;
      }
      if(!query) {this.matches=null;this.output.hidden=true;if(this.native)this.native.hidden=true;this.grid.removeAttribute('aria-busy');return;}
      this.matches=null;this.grid.replaceChildren();this.more.hidden=true;this.empty.hidden=true;
      this.output.hidden=false;if(this.native)this.native.hidden=true;
      this.status.textContent=this.labels.loading || 'Searching…';
      this.grid.setAttribute('aria-busy','true');
      try {
        const products=await load(this.dataset.catalogUrl);
        if(serial!==this.serial || !this.isConnected) return;
        const result=find(products,query);this.matches=result.matches;this.shown=0;this.grid.replaceChildren();
        this.status.textContent=(result.fuzzy && result.matches.length?this.labels.close:this.labels.results).replace('{count}',result.matches.length).replace('{query}',query);
        this.empty.hidden=Boolean(result.matches.length);this.output.hidden=false;if(this.native)this.native.hidden=true;
        this.showMore(false);this.restorePosition();
        if(submitted)this.status.focus({preventScroll:true});
      } catch(error) {
        if(serial!==this.serial || !this.isConnected)return;
        if(submitted) {HTMLFormElement.prototype.submit.call(this.form);return;}
        this.output.hidden=false;this.status.textContent=this.labels.unavailable;this.grid.replaceChildren();this.more.hidden=true;this.empty.hidden=true;
        if(this.native)this.native.hidden=this.nativeURL!==this.appliedURL;
      } finally {if(serial===this.serial)this.grid.removeAttribute('aria-busy');}
    }
    showMore(focus) {
      if(!this.matches)return;
      const start=this.shown,next=this.matches.slice(start,start+this.pageSize);
      next.forEach(match=>this.grid.append(card(match,this.labels)));this.shown+=next.length;
      this.more.hidden=this.shown>=this.matches.length;
      if(focus)this.grid.children[start]?.querySelector('a')?.focus();
    }
  });
  if(!customElements.get('lf-related-products')) customElements.define('lf-related-products',class extends HTMLElement {
    connectedCallback(){
      if(this.started)return;
      this.observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){this.observer.disconnect();this.start();}},{rootMargin:'500px'});
      this.observer.observe(this);
    }
    disconnectedCallback(){this.observer?.disconnect();}
    async start(){
      if(this.started)return;this.started=true;
      try {
        const config=JSON.parse(this.querySelector('[data-lf-related-config]').textContent);
        const products=await load(this.dataset.catalogUrl);
        if(!this.isConnected)return;
        const matches=recommend(products,config.current);
        if(!matches.length)return;
        const grid=this.querySelector('[data-lf-related-grid]');matches.forEach(match=>grid.append(card(match,config.labels)));
        this.querySelector('[data-lf-related-content]').hidden=false;
      }catch(error){this.started=false;}
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lf-gallery-zoom"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('lf-gallery-zoom')) customElements.define('lf-gallery-zoom',class extends HTMLElement {
  connectedCallback(){
    if(this.events)return;
    this.gallery=this.closest('lf-product-gallery');this.dialog=this.querySelector('dialog');this.openButton=this.querySelector('[data-lf-zoom-open]');
    if(!this.gallery || !this.dialog.showModal)return;
    this.events=new AbortController();const options={signal:this.events.signal};
    this.images=Array.from(this.gallery.querySelectorAll('[data-lf-gallery-slide]')).filter(slide=>slide.querySelector('img'));
    if(!this.images.length)return;
    this.stage=this.querySelector('[data-lf-zoom-stage]');this.image=this.querySelector('[data-lf-zoom-image]');this.previous=this.querySelector('[data-lf-zoom-prev]');this.next=this.querySelector('[data-lf-zoom-next]');this.toggle=this.querySelector('[data-lf-zoom-toggle]');this.count=this.querySelector('[data-lf-zoom-count]');
    this.openButton.hidden=false;
    this.openButton.addEventListener('click',()=>this.open(),options);
    this.querySelector('[data-lf-zoom-close]').addEventListener('click',()=>this.dialog.close(),options);
    this.previous.addEventListener('click',()=>this.show(this.active-1),options);
    this.next.addEventListener('click',()=>this.show(this.active+1),options);
    this.toggle.addEventListener('click',()=>this.setZoom(!this.zoomed),options);
    this.dialog.addEventListener('keydown',event=>{
      if(event.key==='ArrowLeft' && !this.zoomed){event.preventDefault();this.show(this.active-1);}
      if(event.key==='ArrowRight' && !this.zoomed){event.preventDefault();this.show(this.active+1);}
    },options);
    this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom)this.dialog.close();}},options);
    this.dialog.addEventListener('close',()=>this.restore(),options);
    window.addEventListener('pagehide',()=>{if(this.dialog.open)this.dialog.close();},options);
  }
  disconnectedCallback(){if(this.dialog?.open){this.dialog.close();this.restore();}this.events?.abort();this.events=null;}
  open(){
    const viewport=this.gallery.querySelector('[data-lf-gallery-viewport]');
    const slides=Array.from(this.gallery.querySelectorAll('[data-lf-gallery-slide]'));
    const current=slides[this.gallery.active ?? Math.round(viewport.scrollLeft/viewport.clientWidth)] || this.images[0];
    const index=this.images.indexOf(current);this.show(Math.max(index,0));
    this.scrollPosition=window.scrollY;this.previousOverflow=document.documentElement.style.overflow;
    document.documentElement.style.overflow='hidden';this.locked=true;this.dialog.showModal();
    this.querySelector('[data-lf-zoom-close]').focus();
  }
  show(index){
    this.active=Math.max(0,Math.min(this.images.length-1,index));
    const source=this.images[this.active].querySelector('img');const url=new URL(source.currentSrc || source.src,location.href);
    url.searchParams.set('width','2048');this.image.src=url.href;this.image.alt=source.alt;
    this.previous.disabled=this.active===0;this.next.disabled=this.active===this.images.length-1;this.count.textContent=(this.active+1)+' / '+this.images.length;this.setZoom(false);
  }
  setZoom(zoomed){
    this.zoomed=zoomed;this.stage.classList.toggle('is-zoomed',zoomed);this.toggle.setAttribute('aria-pressed',String(zoomed));this.toggle.textContent=zoomed?this.toggle.dataset.zoomOut:this.toggle.dataset.zoomIn;requestAnimationFrame(()=>{if(!this.isConnected)return;this.stage.scrollTo({top:zoomed?(this.stage.scrollHeight-this.stage.clientHeight)/2:0,left:zoomed?(this.stage.scrollWidth-this.stage.clientWidth)/2:0,behavior:'instant'});});
  }
  restore(){
    if(!this.locked)return;this.locked=false;
    document.documentElement.style.overflow=this.previousOverflow;
    if(this.isConnected){window.scrollTo({top:this.scrollPosition,behavior:'instant'});this.openButton.focus({preventScroll:true});}
  }
});
  } catch(e) { console.error(e); }
})();

})();
